import { StateKeysArrayType } from 'app/store/types'

export const WHITE_LISTED_REDUCERS: StateKeysArrayType = ['swcClient']
